import { TenantConfigPlane } from '@today/types'
import { TenantGeneralSettingsView } from '@today/ui-domain'
import { useTenantGeneralSettings } from '@/hooks/useTenantGeneralSettings'
import type { TenantConfigSectionProps } from '../section-props'

/**
 * The console's `general` section (TO-125). A Super-Admin (platform plane, EDIT)
 * sets the tenant's default offer expiry; the tenant plane keeps the placeholder
 * (no tenant-plane read of these settings exists yet).
 */
export function GeneralSection({ tenantId, plane }: TenantConfigSectionProps) {
	const platform = plane === TenantConfigPlane.PLATFORM
	const general = useTenantGeneralSettings(tenantId, platform)

	if (!platform) return <p className="text-sm text-ds-text-muted">General settings are managed by the platform.</p>
	if (general.loadFailed) {
		return (
			<div role="alert" className="flex flex-col items-start gap-3 text-sm text-ds-danger">
				<p>Could not load the tenant.</p>
				<button type="button" onClick={general.reload} className="rounded-md border px-3 py-1">
					Try again
				</button>
			</div>
		)
	}
	if (general.loading) {
		return (
			<p className="text-sm text-ds-text-muted" aria-live="polite">
				Loading settings…
			</p>
		)
	}
	return (
		<TenantGeneralSettingsView
			days={general.days}
			fieldError={general.fieldError}
			saveError={general.saveError}
			saving={general.saving}
			onChange={general.onChange}
			onSave={general.onSave}
		/>
	)
}
